import './index.css';

let areaImage = require('./images/area.png');

export default {
  name: 'Amap',
  props: {
    id: { type: String, default: () => (`a-map-${Math.random().toString().substring(2)}`) },
    http: { type: String, default: () => 'https://webapi.amap.com' },
    url: { type: String, default: () => 'https://webapi.amap.com/loader.js' },
    // mapKey: { type: String, default: () => '5b9d39bba940bc041864d83fb325afd4' },
    mapKey: { type: String, default: () => '7e9401417e66edab320680eb027b6d47' },
    mapStyle: { type: String, default: () => 'amap://styles/801c85f8a25c77dd5252337d2c92c942' }, // amap://styles/3c227c09b6ee2f827d977bd2f7ce4ddd
    version: { type: String, default: () => '2.0' },
    boundary: { type: Object, default: () => ({ outer: require('./json/中华人民共和国.json'), inner: require('./json/湖北省.json') }) },
    marker: { // 标记点的回调函数
      type: Function,
      default: (a) => {
        let label = a.shortName || a.title || a.label || a.name || a.text;
        let value = a.number || a.value || a.count || a.code || a.id;
        return (`
          <div class="icon">
            <img src="${areaImage}" />
            <div class="point">
              <div class="node">
                <div class="label">${label}</div>
                <div class="value">${value}</div>
              </div>
              <div class="step1" />
              <div class="step2" />
              <div class="step3" />
            </div>
          </div>
        `);
      },
    },
  },
  data() {
    const { zoom = 7, center = [114.31158155473, 30.598466736401] } = this.$attrs;
    return {
      scriptId: `script-${this.id}`,
      loading: false,
      loader: null,
      AMap: null,
      map: null,
      center,
      zoom,
      markers: [],
      polygons: [],
    }
  },
  created() {
    this.create();
  },
  destroyed() {
    this.cancel();
  },
  watch: {
    boundary: {
      deep: true,
      handler() {
        this.create();
      },
    },
  },
  methods: {
    onload(url, callback = null) {
      let script = document.createElement('script');
      script.id = this.scriptId;
      script.src = url;
      let head = document.querySelector('head');
      head && (head.appendChild(script));
      if (callback) {
        script.onload = script.onreadystatechange = () => {
          if (!script.readyState || (script.readyState == 'loaded' || script.readyState == 'complete')) {
            script.onreadystatechange = null;
            script.onload = null;
            callback();
          }
        };
      }
    },
    create() {
      this.loading = true;
      return new Promise((resolve) => {
        this.onload(this.url, () => {
          if (AMapLoader) {
            this.loader = AMapLoader;
            this.$nextTick(() => {
              this.loader.reset();
              this.$nextTick(() => {
                this.loader.load({ // 首次调用 load
                  key: this.mapKey, // 首次load key为必填
                  version: this.version, // 地图版本号
                  plugins: ['AMap.Scale', 'AMap.ToolBar'], // 地图插件
                }).then((AMap) => {
                  if (AMap) {
                    this.AMap = AMap;
                    this.$nextTick(() => {
                      let inner = this.filter(this.boundary.inner); // 获取父级地图中的子级地图(用于获取经纬度和绘制外边界)
                      if (inner.properties) {
                        const { center = null, centroid = null } = inner.properties; // 获取父级地图中子级地图的坐标
                        this.center = centroid || center || this.center;
                        this.$nextTick(() => {
                          this.map = new this.AMap.Map(this.id, {
                            mapStyle: this.mapStyle.startsWith('amap://styles') ? this.mapStyle : (`amap://styles/${this.mapStyle}`),
                            center: this.center,
                            resizeEnable: true,
                            zoom: this.zoom,
                            zoomEnable: true,
                            dragEnable: true,
                          });
                          this.map.addControl(new AMap.Scale())
                          this.map.addControl(new AMap.ToolBar())
                          this.$nextTick(() => {
                            this.map.clearMap();  // 清除地图覆盖物(地图覆盖物初始化)
                            this.$nextTick(() => {
                              this.draw(this.boundary.outer, { strokeWeight: 1 }).then((done) => {
                                done && (this.draw([inner], { strokeWeight: 3 }).then((done = false) => { // 绘制外层边界
                                  done && (this.draw(this.boundary.inner, { strokeWeight: 1 })); // 绘制内层边界
                                }));
                              });
                              this.$nextTick(() => {
                                resolve(this.map);
                                this.$nextTick(() => this.loading = false);
                              });
                            });
                          });
                        });
                      }
                    });
                  }
                }).catch((a) => console.error('Map loading exception. ', a));
              });
            });
          }
        });
      });
    },
    move(coordinate = []) {
      this.center = coordinate;
      this.$nextTick(() => this.map.panTo(this.center)); // 坐标定位
    },
    draw(featureCollection = null, option = {}) { // 绘制地图边界
      this.loading = true;
      return new Promise((resolve) => {
        let success = false;
        let polygons = []; // 边界线数组集合;
        if (featureCollection) {
          let array = Array.isArray(featureCollection) ? featureCollection : featureCollection.features;
          if (array && (array.length > 0)) {
            array.forEach((a, b) => {
              const { geometry = { coordinates: [] }, properties = { adcode: '', center: [] } } = a;
              const {
                fillColor = '', // 区域颜色
                fillOpacity = 1, // 边框透明
                strokeWeight = 1, // 边框宽度
                strokeStyle = 'solid', // 边框类型
                strokeColor = '#ccebc5', // 边框颜色
                strokeOpacity = 1, // 边框透明
                ...options
              } = option;
              let styles = ({ fillColor, fillOpacity, strokeWeight, strokeStyle, strokeColor, strokeOpacity, ...options });
              let polygon = new this.AMap.Polygon({
                map: this.map,
                id: a.properties.adcode || a.properties.center.join(), // 区域编码
                path: geometry.coordinates, // 边界数据
                ...styles
              });
              if (polygon) {
                polygons[b] = polygon;
                polygon.on('click', () => {
                  this.$nextTick(() => this.$emit('click', properties));
                });
                polygon.on('dblclick', () => {
                  // const { center = null, centroid = null } = properties;
                  // this.locate(centroid || center, this.zoom);
                  this.$nextTick(() => this.$emit('dblclick', properties));
                });
                polygon.on('mouseout', () => {
                  // polygon.setOptions({ ...styles });
                  this.$nextTick(() => this.$emit('mouseout', properties));
                });
                polygon.on('mouseover', () => {
                  // polygon.setOptions({ fillOpacity: 0.2, fillColor: '#ccebc5' });
                  this.$nextTick(() => this.$emit('mouseover', properties));
                });
              };
            });
            this.$nextTick(() => {
              this.polygons = polygons;
              this.$nextTick(() => {
                success = true;
                this.$nextTick(() => {
                  resolve(success);
                  this.$nextTick(() => this.loading = false);
                });
              });
            });
          }
        }
      });
    },
    mark(array = []) {
      this.loading = true;
      return new Promise((resolve) => {
        let success = false;
        let markers = []; // 标记点数组集合;
        if (array.length > 0) {
          array.forEach((a, b) => { // 添加一些分布不均的点到地图上,地图上添加三个点标记，作为参照
            let coordinate = null;
            const { lon = '', lat = '' } = a;
            if (lon && lat) coordinate = [lon, lat];
            let id = a.id || a.uid || a.uuid || a.code || a.value || a.number;
            let title = a.shortName || a.label || a.title || a.text || a.name || id;
            let position = coordinate || (a.center || a.centroid || a.coordinate || a.coordinates);
            let object = ({
              map: this.map,
              id,
              title, // 标记名称
              position,
              clickable: true,
              content: (`<div class="a-map-marker-content ${title} ${a.level} ${position.join()}">${this.marker(a)}</div>`), // Marker回调
              offset: new this.AMap.Pixel(-13, -30), // 设置文本标注偏移量
              label: {
                direction: 'top',
                offset: new this.AMap.Pixel(10, 0), // 设置文本标注偏移量
                content: (`<div class="a-map-marker-label-content ${title} ${a.level} ${position.join()}">${title}</div>`), //设置文本标注内容
              },
              ...a,
            });
            const marker = new this.AMap.Marker(object);
            if (marker) {
              markers[b] = marker;
              marker.on('click', () => {
                this.locate(position, this.zoom);
                this.$nextTick(() => {
                  this.remove(this.markers);
                  this.$nextTick(() => this.$emit('click', a));
                });
              });
              marker.on('dblclick', () => {
                this.$nextTick(() => this.$emit('dblclick', a));
              });
              marker.on('mouseout', () => {
                this.$emit('mouseout', a);
                this.$nextTick(() => this.$emit('mouseout', a));
              });
              marker.on('mouseover', () => {
                this.$nextTick(() => this.$emit('mouseover', a));
              });
            };
          });
          this.$nextTick(() => {
            this.markers = markers;
            this.$nextTick(() => {
              success = true;
              this.$nextTick(() => {
                resolve(success);
                this.$nextTick(() => this.loading = false);
              });
            });
          });
        }
      });
    },
    scale(zoom = this.zoom) {
      this.zoom = zoom;
      this.$nextTick(this.map.setZoom(this.zoom)); // 设置缩放
    },
    clear() { // 清除地图覆盖物(地图覆盖物初始化)
      this.map.clearMap();
    },
    remove(array = this.markers) { // 清除指定的(markers, polygons)对象数组集合
      array && (array.length > 0 && (this.map.remove(array)));
    },
    filter(inner = this.boundary.inner, outer = this.boundary.outer) { // 通过父级地图对象找出父级地图对象中的子级对象
      let data = {};
      if (inner && outer) {
        const { features = [] } = outer;
        if (features.length > 0) {
          let [child] = inner.features;
          if (child && child.properties && child.properties.parent) {
            const { adcode = '' } = child.properties.parent;
            features.forEach(a => a.properties.adcode == adcode && (data = a));
          }
        }
      }
      return data;
    },
    locate(coordinate = [], zoom = this.zoom) { // 坐标定位并缩放
      this.move(coordinate);
      this.$nextTick(() => this.scale(zoom));
    },
    cancel() { // 销毁地图
      if (this.map) {
        this.remove(this.markers); // 删除标记点
        this.$nextTick(() => {
          this.remove(this.polygons); // 删除边界线
          this.$nextTick(() => {
            this.markers = []; // 清空标记点
            this.$nextTick(() => this.polygons = []); // 清空边界线
          });
        });
        this.$nextTick(() => {
          this.map.clearMap();  // 清除地图所有覆盖物(地图覆盖物初始化)
          this.$nextTick(() => {
            this.map.destroy();
            this.$nextTick(() => this.map = null);
          });
        });
      }
      if (this.AMap) this.AMap = null;
      if (this.loader) {
        this.loader.reset(); // 重置地图加载器
        this.$nextTick(() => this.loader = null);
      }
      const bodyScript = document.body.querySelectorAll('script');
      if (bodyScript && (bodyScript.length > 0)) {
        for (let a = 0; a < bodyScript.length; a++) {
          if (bodyScript[a] && (bodyScript[a].src && (bodyScript[a].src.includes(this.http)))) {
            bodyScript[a].remove();
          }
        }
      }
      this.$nextTick(() => {
        let headScript = document.getElementById(this.scriptId);
        if (headScript) headScript.remove();
      });
    },
  },
  render() {
    const { width = '100%', height = '100%', loading = false } = this.$attrs;
    return (<div id={this.id} class="a-map" style={{ width, height }} v-loading={loading || this.loading} element-loading-background="rgba(0, 0, 0, 0.6)" />);
  }
}